export const DEFAULT_PLACEHOLDER = 'Enter postal code or city';
export const MAX_ADDITIONAL_COUNTRIES_LENGTH = 5;
